import React from 'react';
import PropTypes from 'prop-types';
import { toInteger } from 'lodash';
import { withRouter } from 'react-router';
import connect from 'react-redux/lib/connect/connect';

import { PATH } from '../../constants/path';
import { STATIC_ROOT } from '../../constants';
import { SUB_NAV_CATEGORIES } from '../../services/nav/constants';

import { showSubNav, hideSubNav } from '../../services/nav/actions';
import { clearFilter, filterPartnerOnCategory } from '../../services/filter/actions';

import { buildPathPrefix } from '../../utils/directoryUtils';
import { formatCategoryNameForUrl } from '../../services/category/utils';

import SvgComponent from '../SvgComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';

// Colonnes de la grille desktop (cf. NavComponent.scss).
const SUB_NAV_COLUMNS = 4;

class CategoriesSubNavComponent extends React.Component {
    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => this.showSubNav(SUB_NAV_CATEGORIES);
    onMouseLeaveCategories = () => this.hideSubNav();

    onClickCategory = id => {
        const { categories, history } = this.props;

        if (toInteger(id) > 0) {
            const category = categories.filter(curr => toInteger(curr.id) === toInteger(id))[0];

            this.props.filterPartnerOnCategory('directory', Number(category.id));
        } else {
            history.push(`${buildPathPrefix(this.props.locale, false)}/${PATH.MOST_POPULAR_PATH}`);
            this.props.clearFilter('directory');
        }
    };

    getPath = () => {
        const { isOffline, isEbon } = this.props;

        if (isOffline) {
            return PATH.CASHBACK_OFFLINE_CATEGORY_PATH;
        } else if (isEbon) {
            return PATH.CASHBACK_EBON_CATEGORY_PATH;
        } else {
            return PATH.CASHBACK_ONLINE_CATEGORY_PATH;
        }
    };

    render() {
        const { subNav, categories, id, open, ariaLabel } = this.props;

        // Desktop : trois sous-menus montés ensemble, `open` prime sur l'état Redux (mobile).
        const isOpen = open !== undefined ? open : subNav === SUB_NAV_CATEGORIES;

        // Lignes de la grille desktop calculées sur le nombre de catégories : aucun débordement.
        const rows = Math.max(1, Math.ceil(categories.length / SUB_NAV_COLUMNS));

        return (
            <div
                className={`sous-menu-rubriques ${isOpen ? 'open' : ''}`}
                id={id || 'sous-menu-rubriques'}
                aria-label={ariaLabel}
                aria-hidden={isOpen ? undefined : 'true'}
                onMouseEnter={this.onMouseEnterCategories}
                onMouseLeave={this.onMouseLeaveCategories}>
                <div className="conteneur" style={{ gridTemplateRows: `repeat(${rows}, auto)` }}>
                    {categories.map((category, i) => {
                        return (
                            <LocalizedNavLink
                                to={`${this.getPath()}${formatCategoryNameForUrl(category.label)}-${
                                    category.id
                                }`}
                                key={i}
                                onClick={() => this.onClickCategory(category.id)}>
                                {/* Porte l'indicateur de focus, ajusté au picto + texte. */}
                                <span className="sous-menu-libelle">
                                    {/* react-inlinesvg ne relaie pas aria-hidden. */}
                                    <span className="sous-menu-picto" aria-hidden="true">
                                        <SvgComponent
                                            src={`${STATIC_ROOT}/categories/${category.logo}.svg`}
                                        />
                                    </span>
                                    <span>{category.label}</span>
                                </span>
                            </LocalizedNavLink>
                        );
                    })}
                </div>
            </div>
        );
    }
}

CategoriesSubNavComponent.propTypes = {
    categories: PropTypes.array.isRequired,
    subNav: PropTypes.string,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    id: PropTypes.string,
    open: PropTypes.bool,
    ariaLabel: PropTypes.string
};

const mapStateToProps = state => ({
    subNav: state.nav.subNav,
    locale: state.i18n.locale
});

const mapDispatchToProps = {
    showSubNav,
    hideSubNav,
    filterPartnerOnCategory,
    clearFilter
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CategoriesSubNavComponent));



// WEBPACK FOOTER //
// ./src/components/header/CategoriesSubNavComponent.js